import { useState } from 'react'
import classnames from 'classnames'

import { CardSection } from '@components/CardSection'
import Button from '@components/Button'
import AddCreditCardModal from '@components/AddCreditCardModal'
import { CardSectionButton } from '@components/CardSectionButton'

import { getCreditCardShortCode } from 'shared/utils'
import styles from './styles.module.scss'

const getCardDisplayName = card => `${getCreditCardShortCode(card.cardType)} **** ${card.lastFour}`

const PaymentMethodSection = ({ paymentMethods, setPaymentMethod, selectedPaymentMethod }) => {
    const [showAddCardModal, setShowAddCardModal] = useState(false)

    return (
        <>
            {showAddCardModal && <AddCreditCardModal onClose={() => setShowAddCardModal(false)} />}
            <div className="mt-5">
                <h5 className="mb-4">
                    <T>subscription.purchase.label.payment.method</T>
                </h5>
                <CardSection activeSelected={!!selectedPaymentMethod} notActive className="px-3 py-3 mt-6 mb-6">
                    <div className="d-sm-flex justify-content-between">
                        <div className={classnames('d-flex', 'flex-column', styles.paymentSelectionTitle)}>
                            <span className="font-weight-bold">Credit/debit card</span>
                        </div>
                        <div className="d-flex flex-wrap flex-row">
                            {paymentMethods &&
                                paymentMethods.map((p, i) => (
                                    <CardSectionButton
                                        key={i}
                                        onClick={() => setPaymentMethod(p)}
                                        value={getCardDisplayName(p)}
                                        description={p.nickName}
                                        isSelected={p.id === selectedPaymentMethod?.id}
                                        className={styles.paymentMethodBtn}
                                    />
                                ))}
                        </div>
                    </div>
                </CardSection>
                <Button
                    size="small"
                    type="button"
                    btnStyle="link"
                    iconLeft="plus-round"
                    onClick={() => setShowAddCardModal(true)}
                    className="mt-3 mb-3">
                    <T>dashboard.label.add.credit.card</T>
                </Button>
            </div>
        </>
    )
}

export default PaymentMethodSection
